import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cardData: {},
  allPipelineData: [],
  allPipeline: [],
  action: null,
  upcomingTriggersDetails: [],
  allUpcomingRecentTriggerDetails: {},
  scheduledPipelineCount: 0,
};

const pipelineDashboardSlice = createSlice({
  name: 'pipelineDashboardSlice',
  initialState,
  reducers: {
    setAllPipelineData: (state, action) => {
        state.allPipelineData = action.payload;
    },
    setAllPipeline: (state, action) => {
        state.allPipeline = action.payload;
    },
    setDashboardCardData: (state, action) => {
        state.cardData = action.payload;
    },
    setScheduledPipelineCount: (state, action) => {
        state.scheduledPipelineCount = action.payload;
    },
    setUpcomingTriggersDetails: (state, action) => {
        state.upcomingTriggersDetails = action.payload;
    },
    setAction: (state, action) => {
        state.action = action.payload;
    },
    setAllUpcomingRecentTriggerDetails: (state, action) => {
        state.allUpcomingRecentTriggerDetails = action.payload;
    },
  },
});

export const {setAllPipeline, setAllPipelineData, setDashboardCardData, setUpcomingTriggersDetails, setAction, setAllUpcomingRecentTriggerDetails, setScheduledPipelineCount } = pipelineDashboardSlice.actions;

export default pipelineDashboardSlice.reducer;
